import { render, staticRenderFns } from "./DataLog.vue?vue&type=template&id=a66f4aa0&scoped=true&"
import script from "./DataLog.vue?vue&type=script&lang=js&"
export * from "./DataLog.vue?vue&type=script&lang=js&"
import style0 from "./DataLog.vue?vue&type=style&index=0&id=a66f4aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66f4aa0",
  null
  
)

export default component.exports